"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _options = require("@module/options");

var _profile = require("@widget/profile");

var _app = require("@package/app");

var _storybook = require("@pikassa/storybook");

var _react = _interopRequireDefault(require("react"));

var _reactRedux = require("react-redux");

var _defaultModule = _interopRequireDefault(require("./default.module.scss"));

function WithoutPaymentLink(_ref) {
  var inProcess = _ref.inProcess;

  try {
    var getSelectedMerchant = function getSelectedMerchant() {
      return findMerchant(profile['merchant']['id']);
    };

    var findMerchant = function findMerchant(id) {
      return merchants.find(function (merchant) {
        return merchant['id'] === id;
      });
    };

    var updateIdentificationData = function updateIdentificationData() {
      dispatch((0, _options.updateIdentification)(activeMerchant['id']));
    };

    var dispatch = (0, _reactRedux.useDispatch)();
    var profile = (0, _reactRedux.useSelector)(_profile.selectProfile);
    var merchants = (0, _reactRedux.useSelector)(_profile.selectAvailableMerchants);
    var activeMerchant = getSelectedMerchant();
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: _defaultModule["default"]['wrapper'],
      "data-locator": 'identification.new.without_link'
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: _defaultModule["default"]['label'],
      "data-locator": 'identification.new.without_link.label'
    }, "\u041D\u0430\u0447\u0430\u043B\u044C\u043D\u044B\u0439 \u0443\u0440\u043E\u0432\u0435\u043D\u044C"), /*#__PURE__*/_react["default"].createElement(_storybook.Text, {
      type: 'comment',
      className: _defaultModule["default"]['text'],
      "data-locator": 'identification.new.without_link.text'
    }, "\u0414\u043E\u0441\u0442\u0443\u043F\u043D\u044B \u0442\u043E\u043B\u044C\u043A\u043E \u0432\u0445\u043E\u0434\u044F\u0449\u0438\u0435 \u043F\u043B\u0430\u0442\u0435\u0436\u0438. \u0427\u0442\u043E\u0431\u044B \u0441\u043E\u0432\u0435\u0440\u0448\u0430\u0442\u044C \u0432\u044B\u043F\u043B\u0430\u0442\u044B, \u043F\u0440\u043E\u0439\u0434\u0438\u0442\u0435 \u0438\u0434\u0435\u043D\u0442\u0438\u0444\u0438\u043A\u0430\u0446\u0438\u044E \u0447\u0435\u0440\u0435\u0437 \u043E\u043F\u043B\u0430\u0442\u0443 \u0441\u0447\u0435\u0442\u0430 \u0432 \u0441\u0438\u0441\u0442\u0435\u043C\u0435 Pikassa"), inProcess ? /*#__PURE__*/_react["default"].createElement("span", {
      className: _defaultModule["default"]['spinner']
    }, /*#__PURE__*/_react["default"].createElement("span", {
      className: _defaultModule["default"]['spinner__wrapper']
    }, /*#__PURE__*/_react["default"].createElement("span", {
      className: _defaultModule["default"]['spinner__item']
    }))) : /*#__PURE__*/_react["default"].createElement(_storybook.Button, {
      "data-locator": 'increase.level',
      className: _defaultModule["default"]['button'],
      form: 'outline',
      inProcess: inProcess,
      onClick: function onClick() {
        return updateIdentificationData();
      }
    }, "\u041F\u043E\u0432\u044B\u0441\u0438\u0442\u044C \u0443\u0440\u043E\u0432\u0435\u043D\u044C"));
  } catch (e) {
    return /*#__PURE__*/_react["default"].createElement(_app.Error, {
      error: e
    });
  }
}

WithoutPaymentLink.defaultProps = {
  inProcess: false
};
var _default = WithoutPaymentLink;
exports["default"] = _default;